__turbopack_context__.v({
  "controls": "EditOfficeHoursMobileControls-module-scss-module__BLp_dG__controls",
  "mobileCloseButton": "EditOfficeHoursMobileControls-module-scss-module__BLp_dG__mobileCloseButton",
  "primaryButton": "EditOfficeHoursMobileControls-module-scss-module__BLp_dG__primaryButton",
  "root": "EditOfficeHoursMobileControls-module-scss-module__BLp_dG__root",
  "secondaryButton": "EditOfficeHoursMobileControls-module-scss-module__BLp_dG__secondaryButton",
  "title": "EditOfficeHoursMobileControls-module-scss-module__BLp_dG__title",
  "visible": "EditOfficeHoursMobileControls-module-scss-module__BLp_dG__visible",
});
